import data from "../../customData.json";

export const app: any = {};

// Default Company Name
app.defaultCompanyName = "Sample Group";

// Environments
app.inProduction = process.env.NODE_ENV === "production";
app.inMockMode = process.env.REACT_APP_MOCK_MODE === "true"; // default process that are mocked locally
// [LOCAL-DEBUGGING]: helps save time; change environment variable REACT_APP_FULL_MOCK_MODE back to false when finished testing
app.inFullMockMode = process.env.REACT_APP_FULL_MOCK_MODE === "true";

// Main Urls
app.hash = app.inProduction ? "1hz96kjkf2hlpgy15jwlb5m9qgnxvt8thj" : "dev";
app.hashPath = app.inProduction
	? "1hz96kjkf2hlpgy15jwlb5m9qgnxvt8thj/"
	: "dev/";
app.devUrl = `http://localhost:4040/${app.hashPath}`;
app.prodUrl = `/${app.hashPath}`;

// Paths
const apiPath = {
	customize: {
		buildDemo: app.inFullMockMode
			? "mocks/customize/json/buildDemo"
			: "customize/demo/folder",
	},
};

// Requests
const customizeRequest = {
	post: {
		buildDemo: {
			url: {
				dev: `${app.devUrl}${apiPath.customize.buildDemo}`,
				prod: `/${app.hashPath}${apiPath.customize.buildDemo}`,
			},
		},
	},
};

// (LOCAL-DEBUGGING): Emulate server down (for a retry), change post.buildDemo.url.dev to http://localhost:1234;
app.buildDemoUrl = !app.inProduction
	? customizeRequest.post.buildDemo.url.dev
	: customizeRequest.post.buildDemo.url.prod;

app.url = app.inProduction ? app.prodUrl : app.devUrl;
app.startUploadPath =
	app.inProduction || !app.inMockMode
		? "customize/upload"
		: `mocks/pitcher/upload`;

// Retirement Projection Api Request
app.projectionRoute =
	"external/ris/api/public/calculators/retirementprojection"; //api path
// api points to pilot (to resolve any potential issues in production)
app.projectionUrlFull = `https://demo.pilot.principal.com/${app.hashPath}${app.projectionRoute}`; // for all other origins
app.pilotProjectionUrl = `${app.prodUrl}${app.projectionRoute}`;

app.projectionUrl = window.location.origin.includes("pilot")
	? app.pilotProjectionUrl
	: app.projectionUrlFull;
app.projectionMockUrl = `${app.devUrl}${app.projectionRoute}`;
app.wellnessUrl =
	app.inProduction || !app.inMockMode
		? app.projectionUrl
		: app.projectionMockUrl;

// Upload status
app.uploadStatusPath = (jobId) =>
	app.inProduction || !app.inMockMode
		? `customize/upload/status/${jobId}`
		: `mocks/pitcher/upload/status/${jobId}`;

// Custom logic for data
const customWindowObj = window["custom"] || {};
const customProperties = Object.keys(customWindowObj);
customProperties.forEach((property) => {
	data[property] = window["custom"][property] || data[property];
});

// Client logo source
app.clientLogoSrc = `.${process.env.PUBLIC_URL}/img/client-logo.png`;

export default data;
